/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
// import { ImageGrid } from "frontend/src/sections/InstaGrid/ImageGrid"
import { Icon } from "frontend/src/components/Icon"
import { Touchable } from "frontend/src/components/Touchable"
import { SectionGrid, Flex } from "frontend/src/components/Layout"

function InstaGrid({ title = "Instagram", account = "sleep.ink" }) {
  const instaURL = `https://www.instagram.com/${account}/`
  return (
    <SectionGrid sx={{ py: 11 }}>
      <SectionGrid.wide>
        <div
          sx={{
            display: ["block", "block", "flex"],
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            maxWidth: "1300px",
            // maxWidth: "1004px",
          }}
        >
          <Flex.column
            justify="center"
            sx={{
              width: ["300px", "300px", "unset"],
              mx: ["auto", "auto", "unset"],
              mb: 8,
            }}
          >
            <h2
              sx={{
                fontFamily: "heading",
                fontSize: [7, 7, "38px"],
                lineHeight: ["30px", "30px", "44px"],
                fontWeight: ["medium", "medium", "regular"],
                letterSpacing: "-1.24px",
                color: "almostBlack",
                textAlign: ["center", "center", "left"],
                my: "auto",
              }}
            >
              {title}
            </h2>
          </Flex.column>
          <Touchable
            href={instaURL}
            target="_blank"
            rel="noreferrer noopener"
            sx={{ textDecoration: "none" }}
          >
            <Flex.row
              align="center"
              justify={["center", "center", "flex-end"]}
              sx={{
                mb: ["30px", "30px", "41px"],
              }}
            >
              <Icon size={["36px", "48px", "48px"]} name="Instagram" sx={{ mr: 3 }} />
              <span sx={{ variant: "text.h3", color: "almostBlack" }}>{account}</span>
            </Flex.row>
          </Touchable>
        </div>
        {/* <ImageGrid url={instaURL} /> */}
      </SectionGrid.wide>
    </SectionGrid>
  )
}

export { InstaGrid }
